import { IPagination } from "../../data/AppInterface";
import { TReactSetState, TSetPaginationFn } from "../../data/AppType";
import { GET_ALL_AUDIT_LOG } from "../../services/Endpoints";
import {
  DEFAULT_STATUS_CODE_SUCCESS,
  MESSAGE_UNKNOWN_ERROR_OCCURRED,
} from "../../utils/AppConstants";
import { handleError, sweetAlertError } from "../../utils/AppFunctions";

export interface ILog {
  field_name: string;
  old_value: string;
  new_value: string;
}

export interface IAuditLog {
  id?: string;
  action_date: Date;
  action_by: string;
  action: string;
  profile_media_url: string;
  log: [ILog];
}

export const getAuditLog = async (
  handleClose: (status: boolean) => void,
  setAuditLog: TReactSetState<IAuditLog[]>,
  pagination: IPagination,
  setPagination: TSetPaginationFn,
  id: string,
  type: string
) => {
  try {
    const auditLog = await GET_ALL_AUDIT_LOG(pagination, id, type);
    if (auditLog && auditLog.code === DEFAULT_STATUS_CODE_SUCCESS) {
      setAuditLog(auditLog.data.item);
      setPagination(auditLog.data.pagination);
    } else {
      handleClose(false);
      setAuditLog([]);
      sweetAlertError({
        message: auditLog.message || MESSAGE_UNKNOWN_ERROR_OCCURRED,
      });
    }
  } catch (error: any) {
    handleError(error, "getAuditLog");
  }
};
